{
	"tabs": {
		"discount": "Discounts",
		"menus": "Menu",
		"products": "Products",
		"vendorReport": "Vendor report",
		"productReport": "Report by product",
		"orderReport": "Order Report",
		"config": "Settings",
		"extract": "Vendor extract",
		"closings": "Closing by vendor",
		"productSoldByVendor": "Products sold by vendor",
		"vendorsRevenue": "Vendor billing",
		"vendors": "Vendors",
		"invoicesIva": "Invoices",
		"invoicesNational": "Invoices",
		"invoicesBackups": "Backups",
		"missingInvoices": "Missing notes",
		"missingInvoicesForeign": "Pending notes",
		"trasactions": "Transactions",
		"recharges": "Recharges",
		"notEmitedProducts": "Not issued products",
		"search": "Search",
		"emited": "Emissions",
		"emissionErrors": "Emission Errors",
		"fiscalReport": "Fiscal Report",
		"debtorsReport": "Open Invoices"
	},
	"tooltips": {
		"soldProducts": "Total products sold",
		"waiterReport": "Sales per waiter",
		"entranceReport": "Entrance",
		"bonusByProductReport": "Bonus per product",
		"closeCashier": "Closing Cashier",
		"soldEntrances": "Total entrances sold",
		"minimumConsumptionReport": "Early Consumption",
		"cashierBalance": "Revenue per cashier",
		"financialReport": "Closing",
		"vat": "VAT is included in the registered product price.",
		"tipReport": "Tip Report",
		"netValue": "The Net Value is calculated by subtracting the discount and the VAT percentage from the product's Gross Value.",
		"invoiceValue": "Corresponds to the total value of the invoice, which may include more than 1 product, hence more than one line in this table."
	},
	"humanizedWithdrawType": {
		"anticipation": "Anticipation",
		"withdraw": "Withdraw"
	},
	"humanizedWithdrawStatus": {
		"pending": "Pending",
		"paid": "Paid",
		"refused": "Denied",
		"processing": "In processing"
	},
	"parsePaymentMethodV2": {
		"bonus": "Bonus",
		"app": "App",
		"cash": "Cash",
		"creditCard": "Credit Card",
		"debitCard": "Debit Card",
		"postEvent": "Post event",
		"voucher": "Voucher",
		"zigPosCredit": "Integrated Credit",
		"zigPosDebit": "Integrated Debit",
		"pix": "Pix",
		"foodVoucher": "Food Voucher",
		"ame": "Ame",
		"anticipated": "Anticipated",
		"zigPosCreditInInstallments": "Installment",
		"rappi": "Rappi",
		"ifood": "Ifood",
		"uber": "Uber",
		"deliveryOnline": "Delivery Online",
		"dashboard": "Dashboard",
		"Online": "Online",
		"Cashless": "Cashless",
		"mbway": "MBWay",
		"total": "Total",
		"digitalCashless": "Digital Cashless",
		"minimumConsumption": "Minimum consumption",
		"cashless": "Cashless",
		"unknown": "Unknown"
	},
	"defaultErrorMessage": "There was an error with your request",
	"xlsx": {
		"day": "{{title}} on day {{date}}",
		"sinceUntil": "{{title}} between {{since}} and {{until}}",
		"emissionInfo": "Document issued by {{currentEmployee}}, {{date}}",
		"data": "Data",
		"zigEmissionDate": "ZIGPAY - Issue Date {{date}}",
		"selectedPeriod": "selected period {{since}} to {{until}}"
	},
	"displayFiltersInfo": {
		"none": "Filters: No filters applied",
		"hasFilters": "Filters: {{filters}}"
	}
}
